import { Component, OnInit, Injector, HostListener } from '@angular/core';
import { SavedStrategiesModalComponent } from '../SavedStrategiesModal/SavedStrategiesModal.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalGridModeService } from '../../../services/globalGridMode/globalGridMode.service';
import { GridOptions } from 'ag-grid';

@Component({
  selector: 'mobile-saved-strategies-modal',
  template: require('./mobile-saved-strategies-modal.component.html'),
  styles: [require('./mobile-saved-strategies-modal.component.css')]
})
export class MobileSavedStrategiesModalComponent extends SavedStrategiesModalComponent{

  getRowHeight = () => 60;
  constructor(
    injector: Injector,
    public activeModal: NgbActiveModal,
    protected globalGridModeService: GlobalGridModeService,
    protected ngbModalService: NgbModal
  ) {
    super(injector, activeModal, globalGridModeService, ngbModalService);

    this.columnDefs[1].width = 120;
    this.columnDefs[0].cellStyle = Object.assign(this.columnDefs[0].cellStyle || {}, 
    {
      'font-size': '20px !important', 
      'line-height': this.getRowHeight() + 'px !important',
      'text-align': 'left'
    }) as any;
    this.gridOptions.headerHeight = 40;
  }

  public onGridReady(params: GridOptions) 
  {
    super.onGridReady(params);
    this.gridApi.sizeColumnsToFit();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) 
  {
    this.gridApi.sizeColumnsToFit();
  }

}
